{
    "availabilityZones": [
        {
            "azId": 1,
            "color": "#cb512b",
            "height": 120,
            "id": "small-campus-az-1",
            "label": "AVAILABILITY ZONE 1",
            "width": 50,
            "x": 5,
            "y": 95
        },
        {
            "azId": 2,
            "color": "#96e0e4",
            "height": 60,
            "id": "small-campus-az-2",
            "label": "AVAILABILITY ZONE 2",
            "width": 90,
            "x": 105,
            "y": 25
        },
        {
            "azId": 3,
            "color": "#a67de8",
            "height": 180,
            "id": "small-campus-az-3",
            "label": "AVAILABILITY ZONE 3",
            "width": 40,
            "x": 245,
            "y": 95
        }
    ],
    "badges": [],
    "gridUnitPixels": 20,
    "heightUnits": 300,
    "labels": [],
    "lines": [],
    "mapId": "small_campus",
    "mapName": "Small Campus",
    "rackSlots": [
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-56",
            "purpose": "standard",
            "rotation": 90,
            "slot": 56,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-57",
            "purpose": "standard",
            "rotation": 90,
            "slot": 57,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-58",
            "purpose": "standard",
            "rotation": 90,
            "slot": 58,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-59",
            "purpose": "standard",
            "rotation": 90,
            "slot": 59,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-60",
            "purpose": "standard",
            "rotation": 90,
            "slot": 60,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-61",
            "purpose": "standard",
            "rotation": 90,
            "slot": 61,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-62",
            "purpose": "standard",
            "rotation": 90,
            "slot": 62,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-63",
            "purpose": "standard",
            "rotation": 90,
            "slot": 63,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 101
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-48",
            "purpose": "standard",
            "rotation": 90,
            "slot": 48,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-49",
            "purpose": "standard",
            "rotation": 90,
            "slot": 49,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-50",
            "purpose": "standard",
            "rotation": 90,
            "slot": 50,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-51",
            "purpose": "standard",
            "rotation": 90,
            "slot": 51,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-52",
            "purpose": "standard",
            "rotation": 90,
            "slot": 52,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-53",
            "purpose": "standard",
            "rotation": 90,
            "slot": 53,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-54",
            "purpose": "standard",
            "rotation": 90,
            "slot": 54,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-55",
            "purpose": "standard",
            "rotation": 90,
            "slot": 55,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 114
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-40",
            "purpose": "standard",
            "rotation": 90,
            "slot": 40,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-41",
            "purpose": "standard",
            "rotation": 90,
            "slot": 41,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-42",
            "purpose": "standard",
            "rotation": 90,
            "slot": 42,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-43",
            "purpose": "standard",
            "rotation": 90,
            "slot": 43,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-44",
            "purpose": "standard",
            "rotation": 90,
            "slot": 44,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-45",
            "purpose": "standard",
            "rotation": 90,
            "slot": 45,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-46",
            "purpose": "standard",
            "rotation": 90,
            "slot": 46,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-47",
            "purpose": "standard",
            "rotation": 90,
            "slot": 47,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 131
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-32",
            "purpose": "standard",
            "rotation": 90,
            "slot": 32,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-33",
            "purpose": "standard",
            "rotation": 90,
            "slot": 33,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-34",
            "purpose": "standard",
            "rotation": 90,
            "slot": 34,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-35",
            "purpose": "standard",
            "rotation": 90,
            "slot": 35,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-36",
            "purpose": "standard",
            "rotation": 90,
            "slot": 36,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-37",
            "purpose": "standard",
            "rotation": 90,
            "slot": 37,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-38",
            "purpose": "standard",
            "rotation": 90,
            "slot": 38,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-39",
            "purpose": "standard",
            "rotation": 90,
            "slot": 39,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 144
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-24",
            "purpose": "standard",
            "rotation": 90,
            "slot": 24,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-25",
            "purpose": "standard",
            "rotation": 90,
            "slot": 25,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-26",
            "purpose": "standard",
            "rotation": 90,
            "slot": 26,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-27",
            "purpose": "standard",
            "rotation": 90,
            "slot": 27,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-28",
            "purpose": "standard",
            "rotation": 90,
            "slot": 28,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-29",
            "purpose": "standard",
            "rotation": 90,
            "slot": 29,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-30",
            "purpose": "standard",
            "rotation": 90,
            "slot": 30,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-31",
            "purpose": "standard",
            "rotation": 90,
            "slot": 31,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 161
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-16",
            "purpose": "standard",
            "rotation": 90,
            "slot": 16,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-17",
            "purpose": "standard",
            "rotation": 90,
            "slot": 17,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-18",
            "purpose": "standard",
            "rotation": 90,
            "slot": 18,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-19",
            "purpose": "standard",
            "rotation": 90,
            "slot": 19,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-20",
            "purpose": "standard",
            "rotation": 90,
            "slot": 20,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-21",
            "purpose": "standard",
            "rotation": 90,
            "slot": 21,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-22",
            "purpose": "standard",
            "rotation": 90,
            "slot": 22,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-23",
            "purpose": "standard",
            "rotation": 90,
            "slot": 23,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 174
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-8",
            "purpose": "standard",
            "rotation": 90,
            "slot": 8,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-9",
            "purpose": "standard",
            "rotation": 90,
            "slot": 9,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-10",
            "purpose": "standard",
            "rotation": 90,
            "slot": 10,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-11",
            "purpose": "standard",
            "rotation": 90,
            "slot": 11,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-12",
            "purpose": "standard",
            "rotation": 90,
            "slot": 12,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-13",
            "purpose": "standard",
            "rotation": 90,
            "slot": 13,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-14",
            "purpose": "standard",
            "rotation": 90,
            "slot": 14,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-15",
            "purpose": "standard",
            "rotation": 90,
            "slot": 15,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 191
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "eddSlotU": 42,
            "id": "small-campus-floor-slot-0",
            "purpose": "uplink",
            "rotation": 90,
            "slot": 0,
            "type": "standing",
            "width": 7,
            "x": 9,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-1",
            "purpose": "standard",
            "rotation": 90,
            "slot": 1,
            "type": "standing",
            "width": 7,
            "x": 14,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-2",
            "purpose": "standard",
            "rotation": 90,
            "slot": 2,
            "type": "standing",
            "width": 7,
            "x": 19,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-3",
            "purpose": "standard",
            "rotation": 90,
            "slot": 3,
            "type": "standing",
            "width": 7,
            "x": 24,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-4",
            "purpose": "standard",
            "rotation": 90,
            "slot": 4,
            "type": "standing",
            "width": 7,
            "x": 29,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-5",
            "purpose": "standard",
            "rotation": 90,
            "slot": 5,
            "type": "standing",
            "width": 7,
            "x": 34,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-6",
            "purpose": "standard",
            "rotation": 90,
            "slot": 6,
            "type": "standing",
            "width": 7,
            "x": 39,
            "y": 204
        },
        {
            "azId": 1,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-7",
            "purpose": "standard",
            "rotation": 90,
            "slot": 7,
            "type": "standing",
            "width": 7,
            "x": 44,
            "y": 204
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-112",
            "purpose": "standard",
            "rotation": 90,
            "slot": 112,
            "type": "standing",
            "width": 7,
            "x": 109,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-113",
            "purpose": "standard",
            "rotation": 90,
            "slot": 113,
            "type": "standing",
            "width": 7,
            "x": 114,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-114",
            "purpose": "standard",
            "rotation": 90,
            "slot": 114,
            "type": "standing",
            "width": 7,
            "x": 119,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-115",
            "purpose": "standard",
            "rotation": 90,
            "slot": 115,
            "type": "standing",
            "width": 7,
            "x": 124,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-116",
            "purpose": "standard",
            "rotation": 90,
            "slot": 116,
            "type": "standing",
            "width": 7,
            "x": 129,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-117",
            "purpose": "standard",
            "rotation": 90,
            "slot": 117,
            "type": "standing",
            "width": 7,
            "x": 134,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-118",
            "purpose": "standard",
            "rotation": 90,
            "slot": 118,
            "type": "standing",
            "width": 7,
            "x": 139,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-119",
            "purpose": "standard",
            "rotation": 90,
            "slot": 119,
            "type": "standing",
            "width": 7,
            "x": 144,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-120",
            "purpose": "standard",
            "rotation": 90,
            "slot": 120,
            "type": "standing",
            "width": 7,
            "x": 149,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-121",
            "purpose": "standard",
            "rotation": 90,
            "slot": 121,
            "type": "standing",
            "width": 7,
            "x": 154,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-122",
            "purpose": "standard",
            "rotation": 90,
            "slot": 122,
            "type": "standing",
            "width": 7,
            "x": 159,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-123",
            "purpose": "standard",
            "rotation": 90,
            "slot": 123,
            "type": "standing",
            "width": 7,
            "x": 164,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-124",
            "purpose": "standard",
            "rotation": 90,
            "slot": 124,
            "type": "standing",
            "width": 7,
            "x": 169,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-125",
            "purpose": "standard",
            "rotation": 90,
            "slot": 125,
            "type": "standing",
            "width": 7,
            "x": 174,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-126",
            "purpose": "standard",
            "rotation": 90,
            "slot": 126,
            "type": "standing",
            "width": 7,
            "x": 179,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "eddSlotU": 42,
            "id": "small-campus-floor-slot-127",
            "purpose": "uplink",
            "rotation": 90,
            "slot": 127,
            "type": "standing",
            "width": 7,
            "x": 184,
            "y": 31
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-96",
            "purpose": "standard",
            "rotation": 90,
            "slot": 96,
            "type": "standing",
            "width": 7,
            "x": 109,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-97",
            "purpose": "standard",
            "rotation": 90,
            "slot": 97,
            "type": "standing",
            "width": 7,
            "x": 114,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-98",
            "purpose": "standard",
            "rotation": 90,
            "slot": 98,
            "type": "standing",
            "width": 7,
            "x": 119,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-99",
            "purpose": "standard",
            "rotation": 90,
            "slot": 99,
            "type": "standing",
            "width": 7,
            "x": 124,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-100",
            "purpose": "standard",
            "rotation": 90,
            "slot": 100,
            "type": "standing",
            "width": 7,
            "x": 129,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-101",
            "purpose": "standard",
            "rotation": 90,
            "slot": 101,
            "type": "standing",
            "width": 7,
            "x": 134,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-102",
            "purpose": "standard",
            "rotation": 90,
            "slot": 102,
            "type": "standing",
            "width": 7,
            "x": 139,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-103",
            "purpose": "standard",
            "rotation": 90,
            "slot": 103,
            "type": "standing",
            "width": 7,
            "x": 144,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-104",
            "purpose": "standard",
            "rotation": 90,
            "slot": 104,
            "type": "standing",
            "width": 7,
            "x": 149,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-105",
            "purpose": "standard",
            "rotation": 90,
            "slot": 105,
            "type": "standing",
            "width": 7,
            "x": 154,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-106",
            "purpose": "standard",
            "rotation": 90,
            "slot": 106,
            "type": "standing",
            "width": 7,
            "x": 159,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-107",
            "purpose": "standard",
            "rotation": 90,
            "slot": 107,
            "type": "standing",
            "width": 7,
            "x": 164,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-108",
            "purpose": "standard",
            "rotation": 90,
            "slot": 108,
            "type": "standing",
            "width": 7,
            "x": 169,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-109",
            "purpose": "standard",
            "rotation": 90,
            "slot": 109,
            "type": "standing",
            "width": 7,
            "x": 174,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-110",
            "purpose": "standard",
            "rotation": 90,
            "slot": 110,
            "type": "standing",
            "width": 7,
            "x": 179,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-111",
            "purpose": "standard",
            "rotation": 90,
            "slot": 111,
            "type": "standing",
            "width": 7,
            "x": 184,
            "y": 44
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-80",
            "purpose": "standard",
            "rotation": 90,
            "slot": 80,
            "type": "standing",
            "width": 7,
            "x": 109,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-81",
            "purpose": "standard",
            "rotation": 90,
            "slot": 81,
            "type": "standing",
            "width": 7,
            "x": 114,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-82",
            "purpose": "standard",
            "rotation": 90,
            "slot": 82,
            "type": "standing",
            "width": 7,
            "x": 119,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-83",
            "purpose": "standard",
            "rotation": 90,
            "slot": 83,
            "type": "standing",
            "width": 7,
            "x": 124,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-84",
            "purpose": "standard",
            "rotation": 90,
            "slot": 84,
            "type": "standing",
            "width": 7,
            "x": 129,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-85",
            "purpose": "standard",
            "rotation": 90,
            "slot": 85,
            "type": "standing",
            "width": 7,
            "x": 134,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-86",
            "purpose": "standard",
            "rotation": 90,
            "slot": 86,
            "type": "standing",
            "width": 7,
            "x": 139,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-87",
            "purpose": "standard",
            "rotation": 90,
            "slot": 87,
            "type": "standing",
            "width": 7,
            "x": 144,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-88",
            "purpose": "standard",
            "rotation": 90,
            "slot": 88,
            "type": "standing",
            "width": 7,
            "x": 149,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-89",
            "purpose": "standard",
            "rotation": 90,
            "slot": 89,
            "type": "standing",
            "width": 7,
            "x": 154,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-90",
            "purpose": "standard",
            "rotation": 90,
            "slot": 90,
            "type": "standing",
            "width": 7,
            "x": 159,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-91",
            "purpose": "standard",
            "rotation": 90,
            "slot": 91,
            "type": "standing",
            "width": 7,
            "x": 164,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-92",
            "purpose": "standard",
            "rotation": 90,
            "slot": 92,
            "type": "standing",
            "width": 7,
            "x": 169,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-93",
            "purpose": "standard",
            "rotation": 90,
            "slot": 93,
            "type": "standing",
            "width": 7,
            "x": 174,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-94",
            "purpose": "standard",
            "rotation": 90,
            "slot": 94,
            "type": "standing",
            "width": 7,
            "x": 179,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-95",
            "purpose": "standard",
            "rotation": 90,
            "slot": 95,
            "type": "standing",
            "width": 7,
            "x": 184,
            "y": 61
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-64",
            "purpose": "standard",
            "rotation": 90,
            "slot": 64,
            "type": "standing",
            "width": 7,
            "x": 109,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-65",
            "purpose": "standard",
            "rotation": 90,
            "slot": 65,
            "type": "standing",
            "width": 7,
            "x": 114,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-66",
            "purpose": "standard",
            "rotation": 90,
            "slot": 66,
            "type": "standing",
            "width": 7,
            "x": 119,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-67",
            "purpose": "standard",
            "rotation": 90,
            "slot": 67,
            "type": "standing",
            "width": 7,
            "x": 124,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-68",
            "purpose": "standard",
            "rotation": 90,
            "slot": 68,
            "type": "standing",
            "width": 7,
            "x": 129,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-69",
            "purpose": "standard",
            "rotation": 90,
            "slot": 69,
            "type": "standing",
            "width": 7,
            "x": 134,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-70",
            "purpose": "standard",
            "rotation": 90,
            "slot": 70,
            "type": "standing",
            "width": 7,
            "x": 139,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-71",
            "purpose": "standard",
            "rotation": 90,
            "slot": 71,
            "type": "standing",
            "width": 7,
            "x": 144,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-72",
            "purpose": "standard",
            "rotation": 90,
            "slot": 72,
            "type": "standing",
            "width": 7,
            "x": 149,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-73",
            "purpose": "standard",
            "rotation": 90,
            "slot": 73,
            "type": "standing",
            "width": 7,
            "x": 154,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-74",
            "purpose": "standard",
            "rotation": 90,
            "slot": 74,
            "type": "standing",
            "width": 7,
            "x": 159,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-75",
            "purpose": "standard",
            "rotation": 90,
            "slot": 75,
            "type": "standing",
            "width": 7,
            "x": 164,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-76",
            "purpose": "standard",
            "rotation": 90,
            "slot": 76,
            "type": "standing",
            "width": 7,
            "x": 169,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-77",
            "purpose": "standard",
            "rotation": 90,
            "slot": 77,
            "type": "standing",
            "width": 7,
            "x": 174,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-78",
            "purpose": "standard",
            "rotation": 90,
            "slot": 78,
            "type": "standing",
            "width": 7,
            "x": 179,
            "y": 74
        },
        {
            "azId": 2,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-79",
            "purpose": "standard",
            "rotation": 90,
            "slot": 79,
            "type": "standing",
            "width": 7,
            "x": 184,
            "y": 74
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-159",
            "purpose": "standard",
            "rotation": 0,
            "slot": 159,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 100
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-158",
            "purpose": "standard",
            "rotation": 0,
            "slot": 158,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 105
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-157",
            "purpose": "standard",
            "rotation": 0,
            "slot": 157,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 110
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-156",
            "purpose": "standard",
            "rotation": 0,
            "slot": 156,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 115
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-155",
            "purpose": "standard",
            "rotation": 0,
            "slot": 155,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 120
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-154",
            "purpose": "standard",
            "rotation": 0,
            "slot": 154,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 125
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-153",
            "purpose": "standard",
            "rotation": 0,
            "slot": 153,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 130
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-152",
            "purpose": "standard",
            "rotation": 0,
            "slot": 152,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 135
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-151",
            "purpose": "standard",
            "rotation": 0,
            "slot": 151,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 140
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-150",
            "purpose": "standard",
            "rotation": 0,
            "slot": 150,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 145
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-149",
            "purpose": "standard",
            "rotation": 0,
            "slot": 149,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 150
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-148",
            "purpose": "standard",
            "rotation": 0,
            "slot": 148,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 155
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-147",
            "purpose": "standard",
            "rotation": 0,
            "slot": 147,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 160
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-146",
            "purpose": "standard",
            "rotation": 0,
            "slot": 146,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 165
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-145",
            "purpose": "standard",
            "rotation": 0,
            "slot": 145,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 170
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-144",
            "purpose": "standard",
            "rotation": 0,
            "slot": 144,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 175
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-143",
            "purpose": "standard",
            "rotation": 0,
            "slot": 143,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 190
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-142",
            "purpose": "standard",
            "rotation": 0,
            "slot": 142,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 195
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-141",
            "purpose": "standard",
            "rotation": 0,
            "slot": 141,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 200
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-140",
            "purpose": "standard",
            "rotation": 0,
            "slot": 140,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 205
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-139",
            "purpose": "standard",
            "rotation": 0,
            "slot": 139,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 210
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-138",
            "purpose": "standard",
            "rotation": 0,
            "slot": 138,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 215
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-137",
            "purpose": "standard",
            "rotation": 0,
            "slot": 137,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 220
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-136",
            "purpose": "standard",
            "rotation": 0,
            "slot": 136,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 225
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-135",
            "purpose": "standard",
            "rotation": 0,
            "slot": 135,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 230
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-134",
            "purpose": "standard",
            "rotation": 0,
            "slot": 134,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 235
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-133",
            "purpose": "standard",
            "rotation": 0,
            "slot": 133,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 240
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-132",
            "purpose": "standard",
            "rotation": 0,
            "slot": 132,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 245
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-131",
            "purpose": "standard",
            "rotation": 0,
            "slot": 131,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 250
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-130",
            "purpose": "standard",
            "rotation": 0,
            "slot": 130,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 255
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-129",
            "purpose": "standard",
            "rotation": 0,
            "slot": 129,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 260
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-128",
            "purpose": "standard",
            "rotation": 0,
            "slot": 128,
            "type": "standing",
            "width": 7,
            "x": 260,
            "y": 265
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-191",
            "purpose": "standard",
            "rotation": 0,
            "slot": 191,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 100
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-190",
            "purpose": "standard",
            "rotation": 0,
            "slot": 190,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 105
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-189",
            "purpose": "standard",
            "rotation": 0,
            "slot": 189,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 110
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-188",
            "purpose": "standard",
            "rotation": 0,
            "slot": 188,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 115
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-187",
            "purpose": "standard",
            "rotation": 0,
            "slot": 187,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 120
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-186",
            "purpose": "standard",
            "rotation": 0,
            "slot": 186,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 125
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-185",
            "purpose": "standard",
            "rotation": 0,
            "slot": 185,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 130
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-184",
            "purpose": "standard",
            "rotation": 0,
            "slot": 184,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 135
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-183",
            "purpose": "standard",
            "rotation": 0,
            "slot": 183,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 140
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-182",
            "purpose": "standard",
            "rotation": 0,
            "slot": 182,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 145
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-181",
            "purpose": "standard",
            "rotation": 0,
            "slot": 181,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 150
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-180",
            "purpose": "standard",
            "rotation": 0,
            "slot": 180,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 155
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-179",
            "purpose": "standard",
            "rotation": 0,
            "slot": 179,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 160
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-178",
            "purpose": "standard",
            "rotation": 0,
            "slot": 178,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 165
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-177",
            "purpose": "standard",
            "rotation": 0,
            "slot": 177,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 170
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-176",
            "purpose": "standard",
            "rotation": 0,
            "slot": 176,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 175
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-175",
            "purpose": "standard",
            "rotation": 0,
            "slot": 175,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 190
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-174",
            "purpose": "standard",
            "rotation": 0,
            "slot": 174,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 195
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-173",
            "purpose": "standard",
            "rotation": 0,
            "slot": 173,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 200
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-172",
            "purpose": "standard",
            "rotation": 0,
            "slot": 172,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 205
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-171",
            "purpose": "standard",
            "rotation": 0,
            "slot": 171,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 210
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-170",
            "purpose": "standard",
            "rotation": 0,
            "slot": 170,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 215
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-169",
            "purpose": "standard",
            "rotation": 0,
            "slot": 169,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 220
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-168",
            "purpose": "standard",
            "rotation": 0,
            "slot": 168,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 225
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-167",
            "purpose": "standard",
            "rotation": 0,
            "slot": 167,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 230
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-166",
            "purpose": "standard",
            "rotation": 0,
            "slot": 166,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 235
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-165",
            "purpose": "standard",
            "rotation": 0,
            "slot": 165,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 240
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-164",
            "purpose": "standard",
            "rotation": 0,
            "slot": 164,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 245
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-163",
            "purpose": "standard",
            "rotation": 0,
            "slot": 163,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 250
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-162",
            "purpose": "standard",
            "rotation": 0,
            "slot": 162,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 255
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "id": "small-campus-floor-slot-161",
            "purpose": "standard",
            "rotation": 0,
            "slot": 161,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 260
        },
        {
            "azId": 3,
            "capacityU": 42,
            "depth": 5,
            "eddSlotU": 42,
            "id": "small-campus-floor-slot-160",
            "purpose": "uplink",
            "rotation": 0,
            "slot": 160,
            "type": "standing",
            "width": 7,
            "x": 273,
            "y": 265
        }
    ],
    "schema": "uptime-facility-map",
    "version": 2,
    "walls": [
        {
            "id": "small-campus-alpha-north",
            "kind": "exterior",
            "x1": 0,
            "x2": 80,
            "y1": 90,
            "y2": 90
        },
        {
            "id": "small-campus-alpha-west",
            "kind": "exterior",
            "x1": 0,
            "x2": 0,
            "y1": 90,
            "y2": 240
        },
        {
            "id": "small-campus-alpha-south",
            "kind": "exterior",
            "x1": 0,
            "x2": 80,
            "y1": 240,
            "y2": 240
        },
        {
            "id": "small-campus-alpha-east-lower",
            "kind": "exterior",
            "x1": 80,
            "x2": 80,
            "y1": 103,
            "y2": 190
        },
        {
            "id": "small-campus-charlie-north",
            "kind": "exterior",
            "x1": 220,
            "x2": 290,
            "y1": 90,
            "y2": 90
        },
        {
            "id": "small-campus-alpha-office-boundary",
            "kind": "interior",
            "x1": 60,
            "x2": 60,
            "y1": 100,
            "y2": 152
        },
        {
            "id": "small-campus-alpha-service-south",
            "kind": "interior",
            "x1": 20,
            "x2": 20,
            "y1": 220,
            "y2": 227
        },
        {
            "id": "small-campus-charlie-office-boundary",
            "kind": "interior",
            "x1": 240,
            "x2": 240,
            "y1": 90,
            "y2": 280
        },
        {
            "id": "wall-1",
            "kind": "interior",
            "x1": 20,
            "x2": 20,
            "y1": 233.5,
            "y2": 240
        },
        {
            "id": "wall-5",
            "kind": "exterior",
            "x1": 80,
            "x2": 80,
            "y1": 197,
            "y2": 240
        },
        {
            "id": "wall-6",
            "kind": "exterior",
            "x1": 80,
            "x2": 146.5,
            "y1": 110,
            "y2": 110
        },
        {
            "id": "wall-7",
            "kind": "exterior",
            "x1": 80,
            "x2": 80,
            "y1": 97,
            "y2": 0
        },
        {
            "id": "wall-8",
            "kind": "interior",
            "x1": 120,
            "x2": 180,
            "y1": 90,
            "y2": 90
        },
        {
            "id": "wall-9",
            "kind": "interior",
            "x1": 100,
            "x2": 100,
            "y1": 20,
            "y2": 90
        },
        {
            "id": "wall-10",
            "kind": "interior",
            "x1": 60,
            "x2": 60,
            "y1": 216,
            "y2": 220
        },
        {
            "id": "wall-11",
            "kind": "interior",
            "x1": 60,
            "x2": 60,
            "y1": 94,
            "y2": 90
        },
        {
            "id": "wall-12",
            "kind": "interior",
            "x1": 60,
            "x2": 60,
            "y1": 158,
            "y2": 210
        },
        {
            "id": "wall-13",
            "kind": "interior",
            "x1": 200,
            "x2": 200,
            "y1": 90,
            "y2": 20
        },
        {
            "id": "wall-19",
            "kind": "exterior",
            "x1": 80,
            "x2": 220,
            "y1": 0,
            "y2": 0
        },
        {
            "id": "wall-20",
            "kind": "exterior",
            "x1": 220,
            "x2": 220,
            "y1": 0,
            "y2": 97
        },
        {
            "id": "wall-21",
            "kind": "exterior",
            "x1": 0.5,
            "x2": 9,
            "y1": 220,
            "y2": 220
        },
        {
            "id": "wall-4",
            "kind": "exterior",
            "x1": 15,
            "x2": 34,
            "y1": 220,
            "y2": 220
        },
        {
            "id": "wall-3",
            "kind": "exterior",
            "x1": 40.5,
            "x2": 67,
            "y1": 220,
            "y2": 220
        },
        {
            "id": "wall-2",
            "kind": "exterior",
            "x1": 73.5,
            "x2": 80,
            "y1": 220,
            "y2": 220
        },
        {
            "id": "wall-22",
            "kind": "exterior",
            "x1": 220,
            "x2": 220,
            "y1": 103,
            "y2": 190
        },
        {
            "id": "wall-23",
            "kind": "exterior",
            "x1": 153.5,
            "x2": 220,
            "y1": 110,
            "y2": 110
        },
        {
            "id": "wall-24",
            "kind": "interior",
            "x1": 114,
            "x2": 100,
            "y1": 90,
            "y2": 90
        },
        {
            "id": "wall-25",
            "kind": "interior",
            "x1": 186,
            "x2": 200,
            "y1": 90,
            "y2": 90
        },
        {
            "id": "wall-26",
            "kind": "exterior",
            "x1": 87,
            "x2": 80,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "wall-14",
            "kind": "exterior",
            "x1": 93,
            "x2": 124,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "wall-15",
            "kind": "exterior",
            "x1": 130,
            "x2": 190.5,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "wall-16",
            "kind": "exterior",
            "x1": 198,
            "x2": 207,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "wall-17",
            "kind": "exterior",
            "x1": 213,
            "x2": 220,
            "y1": 20,
            "y2": 20
        },
        {
            "id": "wall-18",
            "kind": "interior",
            "x1": 180,
            "x2": 180,
            "y1": 20,
            "y2": 13
        },
        {
            "id": "wall-27",
            "kind": "interior",
            "x1": 180,
            "x2": 180,
            "y1": 7,
            "y2": 0
        },
        {
            "id": "wall-28",
            "kind": "exterior",
            "x1": 290,
            "x2": 290,
            "y1": 90,
            "y2": 300
        },
        {
            "id": "wall-29",
            "kind": "exterior",
            "x1": 290,
            "x2": 260,
            "y1": 280,
            "y2": 280
        },
        {
            "id": "wall-30",
            "kind": "interior",
            "x1": 270,
            "x2": 270,
            "y1": 280,
            "y2": 287
        },
        {
            "id": "wall-31",
            "kind": "interior",
            "x1": 270,
            "x2": 270,
            "y1": 300,
            "y2": 293
        },
        {
            "id": "wall-32",
            "kind": "exterior",
            "x1": 290,
            "x2": 220,
            "y1": 300,
            "y2": 300
        },
        {
            "id": "wall-33",
            "kind": "exterior",
            "x1": 254,
            "x2": 233,
            "y1": 280,
            "y2": 280
        },
        {
            "id": "wall-34",
            "kind": "exterior",
            "x1": 220,
            "x2": 226.5,
            "y1": 280,
            "y2": 280
        },
        {
            "id": "wall-35",
            "kind": "exterior",
            "x1": 220,
            "x2": 220,
            "y1": 197,
            "y2": 300
        }
    ],
    "widthUnits": 290,
    "zones": [
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-sell-zone-1",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 20.5,
            "y": 220.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-delivery-zone-1",
            "label": "DELIVERY\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 45,
            "y": 220.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 15,
            "id": "small-campus-ops-console-1",
            "label": "OPS\nCONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "word",
            "x": 73.5,
            "y": 110
        },
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 6,
            "id": "small-campus-ops-console-2",
            "label": "OPS CONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 16.5,
            "wrapMode": "none",
            "x": 128.5,
            "y": 103.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-delivery-zone-2",
            "label": "DELIVERY\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 130.5,
            "y": 14.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-sell-zone-2",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 173.5,
            "y": 14.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#e95b55",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-sell-zone-3",
            "label": "SELL\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 263.5,
            "y": 280.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "dashed",
            "borderWidth": 0.125,
            "color": "#d9aa2f",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 5,
            "id": "small-campus-delivery-zone-3",
            "label": "DELIVERY\nZONE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 245,
            "y": 280.5
        },
        {
            "borderOpacity": 65,
            "borderStyle": "solid",
            "borderWidth": 0.125,
            "color": "#36c6b1",
            "fillOpacity": 9,
            "fontSize": 0.8,
            "height": 15,
            "id": "small-campus-ops-console-3",
            "label": "OPS\nCONSOLE",
            "labelPosition": "center",
            "lineHeight": 1.2,
            "maxLines": 4,
            "maxWidth": 12,
            "width": 6,
            "wrapMode": "none",
            "x": 220.5,
            "y": 110
        }
    ]
}
